export default __webpack_public_path__ + "static/media/blog.fc0941d6.svg";